import { NotifyHelper } from "../../../helpers/toast";
import { eDotDanhGiaActionTypeDefine } from "../../action-types/danh-gia/IDotDanhGiaActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const dotDanhGiaActions = {
    ...generateActions(eDotDanhGiaActionTypeDefine, "DOT_DANH_GIA"),
    ...generateActionForKey(eDotDanhGiaActionTypeDefine, "DOT_DANH_GIA",
        "SAVE_SUCCESS", () => { NotifyHelper.Success("Saved") }
    ),
    ...generateActionForKey(eDotDanhGiaActionTypeDefine, "DOT_DANH_GIA",
        "DELETE_SUCCESS", () => { NotifyHelper.Success("Saved") }
    ),
    ...generateActionForKey(eDotDanhGiaActionTypeDefine, "DOT_DANH_GIA",
        "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }
    ),
    ...generateActionForKey(eDotDanhGiaActionTypeDefine, "DOT_DANH_GIA",
        "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }
    ),

}